import { Form, Input } from "antd";
export default function PackageModifier({ originForm }) {
  const [form] = Form.useForm(originForm);
  return (
    <Form form={form} labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
      <Form.Item
        style={{ display: "none" }}
        name="id"
      >
        <Input disabled />
      </Form.Item>
      <Form.Item 
        label="单位名称" 
        name="name"
        rules={[
          {
            required: true,
            message: '单位名称必须填写',
          },
          { 
            type: 'string',
            max: 10,
            message: '单位名称最多只能输入10个字符',
          }
        ]}
      >
        <Input placeholder="请输入单位名称" />
      </Form.Item>
    </Form>
  );
}
